import React from 'react';

import APPCONFIG from "constants/Config";
import Framework from "@beardeddevops/react.framework";
import {Collections} from "components";


export default class Dashboard extends Framework.Components.View {

	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div className="container-fluid">

				<Framework.Errors.General isDev={APPCONFIG.settings.isDev()} >
					<Collections.Dashboard
						history={this.props.history}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						locations={this.props.locations}
					/>
				</Framework.Errors.General>

			</div>
		);
	}
}


